import { OutlinedInfoIcon } from 'assets/icons';
import { CustomPopover } from 'components';
import { PopoverArrowTypes } from 'constants/common';
import { FC, useState } from 'react';

const DisplayOrderToolTip: FC = () => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleShowToolTip = () => {
    setShowToolTip(true);
  };

  const handleCloseToolTip = () => {
    setShowToolTip(false);
  };

  const toolTipElement = () => (
    <div onMouseEnter={handleShowToolTip} onMouseLeave={handleCloseToolTip} className="cursor-pointer">
      <OutlinedInfoIcon className="shrink-0" width={16} height={16} />
    </div>
  );

  return (
    <CustomPopover
      showOnTop={true}
      show={showToolTip}
      onTogglePopover={handleShowToolTip}
      onClosePopover={handleCloseToolTip}
      anchorComponent={toolTipElement}
      highlightAnchor={false}
      offset="left-1/2 transform -translate-x-1/2 -top-[130px]"
      showArrow={true}
      arrowType={PopoverArrowTypes.BOTTOM}
      arrowOffset="left-1/2 transform -translate-x-1/2"
      margin="mt-3"
      width="w-[200px]"
      popoverBodyStyle="p-3">
      <div className="text-px13 text-primaryText">
        Sets the priority for how tags appear on a job. Tags are shown in ascending order—lower numbers appear first.
      </div>
    </CustomPopover>
  );
};

export default DisplayOrderToolTip;
